import { render, staticRenderFns } from "./GlobalPopover.vue?vue&type=template&id=59e23089&"
import script from "./GlobalPopover.vue?vue&type=script&lang=js&"
export * from "./GlobalPopover.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports